
import { Swiper, Navigation, Pagination, Autoplay } from "swiper";
import { mapActions } from "vuex";
import BannerCard from "./BannerCard.vue";
export default {
    name: "banner-container",
    components: { BannerCard },
    props: {
        channel_id: Number,
        cat_id: Number,
        pa_page_name: String,
    },
    data() {
        return {
            swiper: ''
        };
    },
    computed: {
        banner_data() {
            return this.$store.state.banner.banner_data;
        },
        banner_img() {
            let bgImage;
            if (this.cat_id !== "" && this.cat_id !==undefined && this.cat_id !== null) {
                bgImage = require('@/static/img/public/channel_banner/'+ this.channel_id + '_' + this.cat_id +'.png')
            } else {
                bgImage = require('@/static/img/public/channel_banner/'+ this.channel_id +'.png')
            }
            return {
                backgroundImage: `url("${bgImage}")`,
            }
        },
        banner_img_m() {
            let bgImage;
            if (this.cat_id !== "" && this.cat_id !==undefined && this.cat_id !== null) {
                bgImage = require('@/static/img/public/channel_banner/'+ this.channel_id + '_' + this.cat_id +'_m.png')
            } else {
                bgImage = require('@/static/img/public/channel_banner/'+ this.channel_id +'_m.png')
            }
            return {
                backgroundImage: `url("${bgImage}")`,
            }
        },
        model_id() {
            return this.$store.state.tag.all_site_model_id;
        }
    },
    methods: {
        ...mapActions("banner", [
            "getBannerData",
            "cleanBannerData"
        ]),
        ...mapActions('tag', [
            'getAllSiteTagData'
        ]),
        paFunction(idx) {
            // console.log(this.banner_data[idx])
            let reg_link = this.banner_data[idx].link.replace('https://','http://');
            let pa_idx = 1 + (idx + 1)/10000;
            window._piq.push(['trackEvent', `rs2022::十大頻道::${this.pa_page_name}`, `imps::大輪播圖::article_carousel::${this.model_id}`, `大輪播圖::${reg_link}`, pa_idx]);
        },
        setSwiper() {
            Swiper.use([Navigation, Pagination, Autoplay]);
            this.swiper = new Swiper(".banner-swiper", {
                direction: "horizontal",
                centeredSlides: true,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        slidesPerGroup: 1
                    },
                    1024: {
                        slidesPerView: 'auto',
                        slidesPerGroup: 1,
                        spaceBetween: 16
                    },
                },
                loop: true,
                modules: [Navigation, Pagination, Autoplay],
                pagination: {
                    el: ".swiper-pagination",
                    type: "bullets",
                    clickable: true
                },
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false
                },
                observer: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }
            });
        }
    },
    async fetch() {
        await this.getBannerData({id: this.channel_id});
        await this.getAllSiteTagData();
    },
    mounted() {
        if (this.banner_data != [] && this.banner_data.length > 0) {
            this.paFunction(0);
        }
        this.setSwiper();
    },
    updated(){
        this.setSwiper();
        this.swiper.on('slideChange', () => {
            this.paFunction(this.swiper.realIndex);
        });
    }
};
